const WorkExperience = [
    {
        id: 1,
        title: "Web Developer",
        company: "Web Development",
        yearsActive: "January 2022 - Present",
        information: [
            "Write modern, performant, maintainable code for a diverse array of internal projects",
        ],
    },
    {
        id: 2,
        title: "Tripura Institute of Technology",
        company: "B.Tech: Computer Science",
        yearsActive: "August 2019 - July 2023",
        information: [
            ""
        ],
    },
    // {
    //     id: 3,
    //     title: "Junior Software Developer",
    //     company: "Empire State",
    //     yearsActive: "Feburary 2016 - April 2017",
    //     information: [
    //         "Planned, developed, tested, deployed, and maintained web applications and mobile applications",
    //         "Worked well independently and on a team to solve problems."
    //     ],
    // },
    // {
    //     id: 4,
    //     title: "Software Development Intern",
    //     company: "The Digital Academy",
    //     yearsActive: "Novembe 2015 - January 2016",
    //     information: [
    //         "Served as a dedicated and supportive Intern in a fast-paced environment",
    //         "Worked to solve complex problems using the latest in Mobile and Web Technologies.",
    //     ],
    // },
    {
        id: 5,
        title: "Golden alley H.S.(+2stage)School",
        company: "TBSE: 12th Grade",
        yearsActive: "August 2017 - May 2019",
        information: [
            ""
        ],
    },
    {
        id: 6,
        title: "Golden alley H.S.(+2stage)School",
        company: "TBSE: 10th Grade",
        yearsActive: "May 2016 - April 2017",
        information: [
            ""]
    },
];

export default WorkExperience;
